module.exports = __webpack_public_path__ + "static/media/dashboard.bf44ef04.svg";